module.exports = __webpack_public_path__ + "images/emoji/peach.e10a479962c9d96f23f9.png";